import { action } from '@ember/object';
import Component from '@glimmer/component';
import { TEXT_FIELD_COPY_TASK_TIMEOUT } from 'admin-panel/constants/ec-timeouts';
import { task, timeout } from 'ember-concurrency';

interface UiInputGroupTextFieldSignature {
  Element: HTMLSpanElement;
  Args: {
    Named: {
      id: string;
      copyButton?: boolean;
      ariaDescribedby?: string;
    };
  };
  Blocks: {
    default: [];
  };
}

export default class UiInputGroupTextFieldComponent extends Component<UiInputGroupTextFieldSignature> {
  @action
  handleCopyClick() {
    const copyElement = document.getElementById(this.args.id);

    if (!copyElement?.textContent) return;

    this.copyTask.perform(copyElement.textContent.trim());
  }

  copyTask = task({ drop: true }, async (text: string) => {
    await timeout(TEXT_FIELD_COPY_TASK_TIMEOUT);
    await navigator.clipboard.writeText(text);
  });
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Ui::InputGroup::TextField': typeof UiInputGroupTextFieldComponent;
    'ui/input-group/text-field': typeof UiInputGroupTextFieldComponent;
  }
}
